import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import Icon from "../Icon";

export const InputXLS = ({ label, file, changeFile, description }) => {
    const [loading, setLoading] = useState(false);
    const ref = useRef();

    const upload = (e) => {
        const selectedFile = ref.current.files[0];

        if (!['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'].includes(selectedFile.type)) {
            toast.error('O formato do arquivo é inválido');
            return;
        }

        setLoading(true);
        changeFile(selectedFile);
        setLoading(false);

        e.target.value = null;
    };

    useEffect(() => {
        if(file === ''){
            if (ref.current) {
            ref.current.value = null;
            }
        }
    }, [file]);

    return (
        <div className={`input-group input-xls-group${label ? ' has-label' : ''}`}>
            {label && <label>{label}</label>}
            <div className="input-file-content">
                <input
                    ref={ref}
                    type="file"
                    onChange={upload}
                    accept=".xls, .xlsx"
                />
                {(!file || file === '') && !loading && (
                    <button className="choose" onClick={() => ref.current.click()} aria-label="Escolher arquivo">
                        <Icon name="upload-small" size={16} /> Escolher
                    </button>
                )}
                {loading && (
                    <button className="loading">
                        <Icon name="loading" size={16} className="spin" /> Carregando...
                    </button>
                )}
                {file && file !== '' && !loading && (
                    <button className="complete" onClick={() => ref.current.click()}>
                        {file.name.length > 30 ? `...${file.name.slice(-30)}` : file.name}
                    </button>
                )}
            </div>
            {description && <span className="desc">{description}</span>}
        </div>
    );
};

export default InputXLS;